import { motion } from "framer-motion";
import { useI18n } from "../../i18n";

const DESTINATIONS = [
  {
    src: "https://customer-assets.emergentagent.com/job_mediterranean-dawn/artifacts/fiv3cb17_La%20Caletta.jpg",
    label: "La Caletta",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mediterranean-dawn/artifacts/gfp33ogr_La%20Cinta.jpg",
    label: "La Cinta",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mediterranean-dawn/artifacts/tywgcjil_Cala%20Gonone.jpg",
    label: "Cala Gonone",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mediterranean-dawn/artifacts/wbzau96o_Porto%20La%20Caletta.jpg",
    label: "Porto La Caletta",
  },
];

export default function Lifestyle() {
  const { t } = useI18n();
  return (
    <section className="relative py-24 md:py-36 lg:py-44 bg-sand-100" data-testid="lifestyle-section">
      <div className="px-6 md:px-12 lg:px-20 max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-y-14 gap-x-8 lg:gap-x-20 items-center">
          {/* 2x2 square composition */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
            className="col-span-12 md:col-span-7"
            data-testid="lifestyle-grid"
          >
            <div className="grid grid-cols-2 gap-3 md:gap-4 aspect-square">
              {DESTINATIONS.map((d, i) => (
                <motion.figure
                  key={i}
                  initial={{ opacity: 0, scale: 0.96 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 1, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                  className="relative overflow-hidden rounded-sm bg-sand-200 shadow-[0_14px_40px_-20px_rgba(31,31,29,0.18)] group"
                  data-testid={`destination-${i}`}
                >
                  <img
                    src={d.src}
                    alt={d.label}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.04]"
                  />
                  <div className="absolute inset-0 bg-charcoal/0 group-hover:bg-charcoal/10 transition-colors duration-700" />
                  <figcaption className="absolute bottom-3 left-3 text-[0.6rem] tracking-luxe uppercase text-ivory bg-charcoal/30 backdrop-blur-sm px-2.5 py-1 opacity-90">
                    {d.label}
                  </figcaption>
                </motion.figure>
              ))}
            </div>
          </motion.div>

          <div className="col-span-12 md:col-span-5 md:pl-2 lg:pl-4">
            <span className="eyebrow">{t.lifestyle.eyebrow}</span>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-charcoal mt-4 whitespace-pre-line"
              data-testid="lifestyle-title"
            >
              {t.lifestyle.title}
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.15 }}
              className="mt-8 text-charcoal-soft text-base md:text-lg leading-relaxed"
            >
              {t.lifestyle.body}
            </motion.p>
            <motion.blockquote
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.3 }}
              className="mt-10 border-l border-charcoal/30 pl-5 font-serif italic text-xl md:text-2xl text-charcoal leading-snug"
            >
              "{t.lifestyle.quote}"
            </motion.blockquote>
          </div>
        </div>
      </div>
    </section>
  );
}
